import React from 'react';
import PropTypes from 'prop-types';

import './footer-countrybar.less';

export const CountryBar = ({ children, onToggleCountries, countryFlagUrl, countryName }) => {
    return (
        <div className="country-bar-container">
            <div className="popover-arrow-right">
                <div className="background-arrow" />
                <div className="foreground-arrow" />
            </div>
            <div className="country-bar">
                Country / Region:
                <img className="flag" src={countryFlagUrl} alt="Country flag" />
                <button type="button" onClick={onToggleCountries}>
                    {countryName}
                </button>
            </div>
            {children}
        </div>
    );
};

CountryBar.defaultProps = {
    children: null,
};

CountryBar.propTypes = {
    /** list of country element contents to be displayed */
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    /** toggle action on click */
    onToggleCountries: PropTypes.func.isRequired,
};

export default CountryBar;
